import React, { createContext, useState, useContext, ReactNode } from 'react';
import ReactDOM from 'react-dom';

import Modal from '../Modal/Modal';

import { AvailibilityOption, Wishlist, Market } from '../../types';
import { disableBodyScroll, enableBodyScroll } from '../../helpers';

interface ModalProviderProps {
    children?: React.ReactNode;
    wishlist?: Wishlist[];
    market?: Market;
    discount?: number;
}

interface IModalContext {
    showModal: (id: string, content: React.ReactNode) => void;
    closeModal: (id: string) => void;
    wishlist?: Wishlist[];
    market?: Market;
    discount?: number;
}

const ModalContext = createContext<IModalContext | undefined>(undefined);

export const ModalProvider: React.FC<ModalProviderProps> = ({
    children,
    wishlist,
    market,
    discount,
    ...props
}) => {
    const [modal, setModal] = useState({ id: null, content: null });

    const showModal = (id: string, content: React.ReactNode) => {
        setModal({ id, content });
        disableBodyScroll();
    };

    const closeModal = (id: string) => {
        if (modal.id === id) {
            setModal({ id: null, content: null });
        }
        enableBodyScroll();
    };

    return (
        <ModalContext.Provider
            value={{
                showModal,
                closeModal,
                wishlist,
                market,
                discount
            }}
        >
            {children}
            {modal.content &&
                ReactDOM.createPortal(
                    <Modal
                        id={modal.id}
                        children={modal.content}
                    ></Modal>,
                    document.body
                )}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    return useContext(ModalContext);
};
